<template>
  <footer class="site-footer">
    <div class="site-footer-inner">
      <div class="site-footer-left">
        <a href="https://facebook.com" target="_blank" class="site-footer-link">
          <i class="fab fa-facebook-f site-footer-icon"></i>
          <span>Facebook</span>
        </a>
        <a href="https://twitter.com" target="_blank" class="site-footer-link">
          <i class="fab fa-twitter site-footer-icon"></i>
          <span>Twitter</span>
        </a>
        <a href="https://instagram.com" target="_blank" class="site-footer-link">
          <i class="fab fa-instagram site-footer-icon"></i>
          <span>Instagram</span>
        </a>
      </div>
      <div class="site-footer-right">
        <span class="site-footer-text">@ KIEY 2026</span>
        <a href="https://kiey.com/terms.html" target="_blank" rel="noopener" class="site-footer-link">Terms of Use</a>
        <a href="https://kiey.com/privacy-policy.html" target="_blank" rel="noopener" class="site-footer-link">Privacy Policy</a>
        <a @click="$router.push('/licenses')" class="site-footer-link">Licenses</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "SiteFooter"
};
</script>

<style scoped>
.site-footer {
  background: #fff;
  padding: 12px 40px;
  width: 100%;
}

.site-footer-inner {
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
}

.site-footer-left,
.site-footer-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.site-footer-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #061D47;
  text-decoration: none;
  font-size: 13px;
  font-weight: 400;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  cursor: pointer;
}

.site-footer-link:hover {
  opacity: 0.7;
}

.site-footer-icon {
  font-size: 16px;
  background-color: #061D47;
  color: #fff;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.site-footer-text {
  color: #061D47;
  font-size: 13px;
  font-weight: 400;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
}

@media (max-width: 768px) {
  .site-footer-inner {
    flex-direction: column;
    gap: 8px;
  }
  .site-footer {
    padding: 8px 16px;
  }
}
</style>
